import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { Panel } from '@prisjakt/ui/panel';
import { GridRow } from '@prisjakt/ui/list/variants';

export const PanelWithGutter = styled(Panel)`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;

export const RowWithWrap = styled(GridRow)`
  flex-wrap: wrap;
`;

export const FlipClockWrapper = styled.div`
  ${media.smallOnly`
    scale: 0.75;
  `}
`;
